import { defineMessages } from 'react-intl';

export const spotlightMessages: {
	spotlightHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	spotlightSeeRelationshipsDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	spotlightManageHierarchyDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	spotlightDismissButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	spotlightImageAltText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	spotlightHeading: {
		id: 'jira-nin-grouping-with-hierarchy-spotlight.spotlightHeading',
		defaultMessage: 'Show hierarchy when grouping',
		description: 'Heading for the grouping with hierarchy spotlight',
	},
	spotlightSeeRelationshipsDescription: {
		id: 'jira-nin-grouping-with-hierarchy-spotlight.spotlightSeeRelationshipsDescription',
		defaultMessage: 'See relationships between work items when you group the list view.',
		description: 'Description for the grouping with hierarchy spotlight',
	},
	spotlightManageHierarchyDescription: {
		id: 'jira-nin-grouping-with-hierarchy-spotlight.spotlightManageHierarchyDescription',
		defaultMessage:
			'To manage hierarchy, select <b>More actions (...)</b> at the top-right of your list.',
		description: 'Description for the grouping with hierarchy spotlight',
	},
	spotlightDismissButton: {
		id: 'jira-nin-grouping-with-hierarchy-spotlight.spotlightDismissButton',
		defaultMessage: 'Done',
		description: 'Dismiss button for the grouping with hierarchy spotlight',
	},
	spotlightImageAltText: {
		id: 'jira-nin-grouping-with-hierarchy-spotlight.spotlightImageAltText',
		defaultMessage:
			'Illustration of the hierarchy toggle enabled when grouping is applied in the List View.',
		description: 'Alt text for the grouping with hierarchy spotlight image',
	},
});
